import classnames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./close-button.css";

function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return React.createElement("button", {
    onClick: onClick,
    className: classnames(className, styles.button)
  }, React.createElement(SVGIcon, {
    name: "cross-thin"
  }));
}

export default CloseButton;
CloseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};